import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["classes"];
import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import withStyles from '@mui/styles/withStyles';
import { green } from '@mui/material/colors';
import PropTypes from 'prop-types';
var styles = function styles() {
  return {
    buttonProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12
    }
  };
};
var Component = function Component(_ref) {
  var classes = _ref.classes,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CircularProgress, _extends({
    className: classes.buttonProgress
  }, rest));
};
export default withStyles(styles)(Component);